import {DataFetcher} from '@aboutyou/data-fetcher';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useBasketCoinsSection} from '../hooks/useGetBasketPageSection';
import {BasketCoinsView} from './BasketCoinsView';

interface BasketCoinsProps {
  LayoutComponent: ContentPopperProps['LayoutComponent'];
  className?: string;
  stickyHeight?: number;
}

export const BasketCoins = (props: BasketCoinsProps) => {
  const {isAuthenticated} = useIsAuthenticated();
  const {isActive} = useIsFeatureActive('ff_coins_rollout');

  if (!isActive || !isAuthenticated) {
    return null;
  }

  return <BasketCoinsFetcher {...props} />;
};

const BasketCoinsFetcher = (props: BasketCoinsProps) => {
  return (
    <DataFetcher
      request={useBasketCoinsSection()}
      Error={() => null}
      View={BasketCoinsView}
      viewProps={props}
    />
  );
};
